export default __webpack_public_path__ + "static/media/spin-bg-4.c623648c.png";